export default Object.freeze({
  FormField: 'form-field',
  Variable: 'variable',
  IterationStepData: 'iteration-step-data',
});
